import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { EditActivity } from 'containers/forms/dashboard'
import { MaterialModal } from 'components/layout'
import getActivityClassName from 'helpers/dashboard/getActivityClassName'

export default class EditActivityModal extends Component {
  static propTypes = {
    activity: PropTypes.object,
    awardLevel: PropTypes.object,
    modalId: PropTypes.string,
  }

  render() {
    const { activity, modalId } = this.props

    const colorClass = getActivityClassName(get(activity, 'activitySection.value'))

    return (
      <MaterialModal.Body
        id={modalId}
        colorClass={colorClass}
        title='Edit Activity'
        titleKey='moduleTitle.edit_activity'
      >
        <MaterialModal.Content>
          <EditActivity {...this.props} colorClass={colorClass} />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
